import { YStack } from '@mythical/ui'
import { FAQs as FAQsType } from 'app/blocks/faqs'
import { mapExcludedPlatforms } from 'app/utils/mapExcludedPlatforms'
import { Platform } from 'react-native'

import Faq from '../primitive/Faq'
import { MarketingHeading } from 'app/features/landing/components'
import { Container } from '../structure/Container'

interface Props {
  block: FAQsType
  standalone?: boolean // If true, adds a container and a title to the block (for landing page)
}

export const FAQsBlock = ({ block, standalone }: Props) => {
  const faqs = block.faqs.filter(
    (faq) =>
      !mapExcludedPlatforms(faq.excludedPlatforms)?.includes(Platform.OS),
  )

  if (faqs.length === 0) return null

  return (
    <Container
      gap="$5"
      $gtSm={{ gap: '$10' }}
      paddedX={standalone}
      centered={standalone}
      variant={standalone ? 'mediumLarge' : 'none'}
    >
      {standalone && (
        <MarketingHeading tag="h2" textAlign="left">
          FAQ
        </MarketingHeading>
      )}

      <YStack>
        {faqs.map((faq) => (
          <Faq key={faq.id} question={faq.question} answer={faq.answer} />
        ))}
      </YStack>
    </Container>
  )
}
